import { Trans, useLingui } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconCalendarEdit from '@/icons/CalendarEdit.svg';
import { formatDate } from '@/utils/date';

export const ArticleStatusDueAtUpdatedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_status_due_at_manually_updated'>;
  displayArticleName: boolean;
}) => {
  const { t } = useLingui();
  const creatorName = activity.creator?.name;
  const after = formatDate(new Date(String(activity.data.after)), {
    dateStyle: 'medium',
  });
  const before = formatDate(new Date(String(activity.data.before)), {
    dateStyle: 'medium',
  });
  const task =
    activity.data.task === 'exchange_article'
      ? t({
          id: 'activities.article_status_due_at_manually_updated.exchange_task',
          message: 'exchange',
        })
      : t({
          id: 'activities.article_status_due_at_manually_updated.repair_task',
          message: 'repair',
        });

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconCalendarEdit />}
      message={
        <BaseActivityText>
          <Trans id="activities.article_status_due_at_manually_updated.message">
            <strong>{creatorName}</strong> changed the {task} completion date from{' '}
            <strong>{before}</strong> to <strong>{after}</strong> for the item{' '}
            <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
